// extracted by mini-css-extract-plugin
export default {"padded_cell":"TaskMessages_padded_cell__2wrUY","item_resolved":"TaskMessages_item_resolved__JS832"};